import React, { FC, useMemo } from 'react';
import { MessageDirection } from 'models/twilio';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { COLORS } from 'components/twilio/constants';
import { VideocamRounded } from '@material-ui/icons';
import ColoredMaterialIcon, { ColoredMaterialIconProps } from '../styled/ColoredMaterialIcon';

const VideoCallMessageContainer = styled.div<{ $direction: MessageDirection }>`
  display: flex;
  flex-direction: ${({ $direction }) => ($direction === MessageDirection.INCOMING ? 'row' : 'row-reverse')};
  line-height: 24px;
`;

export interface VideoCallMessageProps {
  body: string;
  direction: MessageDirection;
}

const VideoCallMessage: FC<VideoCallMessageProps> = ({ body, direction }) => {
  const { t } = useTranslation();
  const iconProps = useMemo((): ColoredMaterialIconProps => ({
    Icon: VideocamRounded,
    color: direction === MessageDirection.OUTGOING ? COLORS.WHITE : COLORS.TEXT_DARK,
    overrides: direction === MessageDirection.OUTGOING ? { marginRight: '4px' } : { marginLeft: '4px' },
  }), [direction]);

  return (
    <VideoCallMessageContainer $direction={direction}>
      {t(body, body)}
      <ColoredMaterialIcon {...iconProps} />
    </VideoCallMessageContainer>
  );
};

export default React.memo(VideoCallMessage);
